import commonJsModule from "cep-webpack-plugin"

export default commonJsModule.default